import React, { useState } from "react";
import useFetchPopularFood from "../hooks/useFetchPopularFood";
import FoodCard from "./FoodCard";
import LoadIcon from "../img/icon/loading.gif";
import { useLanguage } from "../i18n/LanguageContext";

const PopularFoods = () => {
  const { t } = useLanguage();
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 8;

  // Calling the `useFetchPopularFood` hook for fetching popular food data
  const { isLoading, error, data } = useFetchPopularFood(pageNumber, pageSize);

  const results = data?.results ?? [];
  const totalResults = data?.totalResults ?? 0;
  const hasNextPage = pageNumber * pageSize < totalResults;

  // Define two functions to handle pagination
  const handleNextPage = () => {
    setPageNumber((prevPageNumber) => prevPageNumber + 1);
  };
  const handlePrevPage = () => {
    setPageNumber((prevPageNumber) => prevPageNumber - 1);
  };

  // If the data is loading, show a loading icon
  if (isLoading) {
    return (
      <div className="p-0 m-0 bg-gray-200">
        <h1 className="text-center text-2xl font-bold text-gray-700 ">
          {t("popular.heading")}
        </h1>
        <img src={LoadIcon} alt={t("common.loadingAlt")} className="mx-auto" />
      </div>
    );
  }

  // If there is an error, show an inline error message
  if (error) {
    return (
      <div className="bg-gray-200">
        <h1 className="text-center text-2xl font-bold text-gray-700 mb-28">
          {t("popular.heading")}
        </h1>
        <p className="bg-red-600 text-white text-center py-2">
          {t("common.loadError")}
        </p>
      </div>
    );
  }

  // If there is data, render it
  return (
    <div className="bg-gray-200 ">
      <div>
        <h1 className="text-center text-2xl font-bold text-gray-700 mb-28">
          {t("popular.heading")}
        </h1>
      </div>
      {/* Food Card */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4  md:px-28 px-10">
        {results.length === 0 ? (
          <p className="text-center text-gray-700">{t("popular.empty")}</p>
        ) : (
          results.map((recipe) => <FoodCard key={recipe.id} recipe={recipe} />)
        )}
      </div>
      {/* Prev and Next Button */}
      {results.length > 0 ? (
        <div className="flex justify-center md:p-10 p-6">
          <button
            onClick={handlePrevPage}
            disabled={pageNumber === 1}
            className={`font-bold py-2 px-4 rounded mr-2 text-white ${
              pageNumber === 1
                ? "bg-gray-400 "
                : "bg-gray-600 hover:bg-gray-700 "
            } `}
          >
            {t("common.prev")}
          </button>
          <button
            onClick={handleNextPage}
            disabled={!hasNextPage}
            className={`font-bold py-2 px-4 rounded mr-2 text-white ${
              !hasNextPage
                ? "bg-gray-400 "
                : "bg-gray-600 hover:bg-gray-700 "
            } `}
          >
            {t("common.next")}
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default PopularFoods;
